import { PhotoSwipeLightbox } from "./vendor.min.js";

class SizeChartViewer extends HTMLElement {
  connectedCallback() {
    if (this._isInitialized) {
      return;
    }

    this._isInitialized = true;
    this._openButton = this.querySelector("[data-size-chart-open]");
    this._openButton?.addEventListener("click", this._open.bind(this));
  }

  disconnectedCallback() {
    this._lightbox?.destroy();
  }

  get lightbox() {
    if (this._lightbox) {
      return this._lightbox;
    }

    const lightbox = new PhotoSwipeLightbox({
      pswpModule: () => import("./photoswipe.min.js"),
      mainClass: "size-chart-pswp",
      bgOpacity: 0.96,
      closeTitle: window.themeVariables.strings.closeGallery,
      zoomTitle: window.themeVariables.strings.zoomGallery,
      errorMsg: window.themeVariables.strings.errorGallery,
      showHideAnimationType: "fade",
      maxZoomLevel: 4,
      wheelToZoom: true,
      arrowPrev: false,
      arrowNext: false,
      counter: false,
      zoom: true,
    });

    lightbox.init();
    this._lightbox = lightbox;

    return lightbox;
  }

  _open() {
    this.lightbox.loadAndOpen(0, [
      {
        src: this.dataset.imageSrc,
        width: Number(this.dataset.imageWidth),
        height: Number(this.dataset.imageHeight),
        alt: this.dataset.imageAlt,
      },
    ]);
  }
}

if (!window.customElements.get("size-chart-viewer")) {
  window.customElements.define("size-chart-viewer", SizeChartViewer);
}
